import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import styled from "styled-components";
import { GetSubscriptionSetData } from "../../../../../Api/ServiceDatas";
import { useApi } from "../../../../../hooks/useApi";
import LineBtn from "../../../../Button/LineBtn";
import FixedInfoBox from "../../../../DefaultStyles/FixedInfoBox";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import {
  ModalSection,
  ModalSectionLabel,
} from "../../PartyDetail/PartyExitModal/PartyExitModal";
import { recentChatBtnClick } from "./OldChatSeachResult";
import { chatTabState } from "../ChatTab";
import ChatReportRegisterModal from "./OldChatReportRegisterModal";
import { IChatReportComplete } from "./OldReportComplete";
import { isNewChat } from "../../../../../pages/Party/ChatInfo";
import { getSubsNameBySubsId3 } from "../../../../../AdminApi/3.0_utils";

interface ChatReportDetailModalProps {
  closeEvent: () => void;
  data: IChatReportComplete;
  isChatReportCompleteModal?: boolean;
}

export default function ChatReportDetailModal({
  closeEvent,
  data,
  isChatReportCompleteModal,
}: ChatReportDetailModalProps) {
  const setTab = useSetRecoilState(chatTabState);
  const setRecentBtnClick = useSetRecoilState(recentChatBtnClick);

  const navigate = useNavigate();
  const [reportRegisterModal, setReportRegisterChat] = useState(false);

  // 채팅 신고 처리사항 / 처리자 조회
  const { response } = useApi({
    method: "get",
    url: isChatReportCompleteModal ? `oldchat/report/${data?.key}` : undefined,
  });

  console.log(response);

  return (
    <DefaultModalLayout
      closeEvent={() => closeEvent()}
      modalTitle={
        isChatReportCompleteModal
          ? "채팅 신고 처리 완료"
          : "채팅 신고 내용 및 접수"
      }
      confirmEvent={() => {
        if (isChatReportCompleteModal) {
          closeEvent();
        } else {
          setReportRegisterChat(true);
        }
      }}
      confirmBtnText={isChatReportCompleteModal ? "닫기" : "신고 접수"}
      leftBottomBtn={
        isChatReportCompleteModal ? undefined : (
          <LineBtn
            btnText="관련 채팅 보기"
            icon="launch"
            btnHeight={38}
            btnClickEvent={() => {
              setTab(1);
              setRecentBtnClick(true);
              navigate({
                pathname: `/party/chat`,
                search: `${data?.party?.partyid}@${data?.owner}@${
                  String(data?.owner) === data?.uid?.uid
                    ? data?.target?.uid
                    : data?.uid?.uid
                }`,
              });
            }}
          />
        )
      }
      leftBottomTime={response?.data?.time ?? undefined}
      cancelBtn={
        isChatReportCompleteModal ? (
          <LineBtn
            btnText="관련 채팅 보기"
            icon="launch"
            btnHeight={38}
            btnClickEvent={() => {
              setTab(1);
              setRecentBtnClick(true);
              navigate({
                pathname: `/party/chat`,
                search: `${data?.party?.partyid}@${data?.owner}@${
                  String(data?.owner) === data?.uid?.uid
                    ? data?.target?.uid
                    : data?.uid?.uid
                }`,
              });
            }}
          />
        ) : undefined
      }
      leftBottomName={response?.data?.admin}
    >
      {/* 신고자 */}
      <ModalSection>
        <ModalSectionLabel>신고자</ModalSectionLabel>

        <ValueContainer>
          <div
            style={{ flex: 2 }}
            onClick={() =>
              window.open(`/users/info/${data?.uid?.uid}`, "_blank")
            }
          >
            <FixedInfoBox
              label="UID"
              value={`${data?.uid?.uid}_${data?.uid?.name}_${data?.uid?.nickname}`}
              hasArrow={true}
              padding="11px 8px 11px 16px"
            />
          </div>

          <div style={{ flex: 1 }}>
            <FixedInfoBox
              label="구분"
              value={
                String(data?.owner) === data?.uid?.uid ? "파티장" : "파티원"
              }
              sHeight={62.5}
            />
          </div>
        </ValueContainer>
      </ModalSection>

      {/* 신고 대상 */}
      <ModalSection>
        <ModalSectionLabel>신고 대상</ModalSectionLabel>

        <ValueContainer>
          <div
            style={{ flex: 2 }}
            onClick={() =>
              window.open(`/users/info/${data?.target?.uid}`, "_blank")
            }
          >
            <FixedInfoBox
              label="UID"
              value={`${data?.target?.uid}_${data?.target?.name}_${data?.target?.nickname}`}
              hasArrow={true}
              padding="11px 8px 11px 16px"
            />
          </div>

          <div style={{ flex: 1 }}>
            <FixedInfoBox
              label="구분"
              value={
                String(data?.owner) === data?.target?.uid ? "파티장" : "파티원"
              }
              sHeight={62.5}
            />
          </div>
        </ValueContainer>
      </ModalSection>

      {/* 파티 정보 */}
      <ModalSection>
        <ModalSectionLabel>파티 정보</ModalSectionLabel>

        <ValueContainer>
          <div style={{ flex: 1 }}>
            <FixedInfoBox label="PID" value={data?.party?.partyid} />
          </div>

          <div style={{ flex: 2 }}>
            <FixedInfoBox
              label="Subscription"
              value={`${data?.party?.servsubsid}_${getSubsNameBySubsId3(
                data?.party?.servsubsid ?? 0
              )}`}
            />
          </div>
        </ValueContainer>
      </ModalSection>

      {/* 사유 */}
      <ModalSection>
        <ModalSectionLabel>사유</ModalSectionLabel>

        <ValueContainer>
          <FixedInfoBox label="사유 구분" value={data?.reason} />
        </ValueContainer>
      </ModalSection>

      {/* 신고 Msg_ID */}
      <ModalSection>
        <ModalSectionLabel>신고 Msg_ID</ModalSectionLabel>

        <ValueContainer>
          <FixedInfoBox value={data?.msgList?.toString()} padding={"16px"} />
        </ValueContainer>
      </ModalSection>

      {/* 신고 일시 */}
      <ModalSection>
        <ModalSectionLabel>신고 일시</ModalSectionLabel>

        <ValueContainer>
          <FixedInfoBox value={data?.time} sHeight={38} />
        </ValueContainer>
      </ModalSection>

      {/* 처리 내용 */}
      <>
        {isChatReportCompleteModal && (
          <ModalSection>
            <ModalSectionLabel>처리 내용</ModalSectionLabel>

            <ValueContainer>
              <FixedInfoBox value={response?.data?.reason} />
            </ValueContainer>
          </ModalSection>
        )}
      </>

      <>
        {reportRegisterModal && (
          <ChatReportRegisterModal
            closeEvent={() => {
              setReportRegisterChat(false);
            }}
            confirmEvent={() => closeEvent()}
            chatKey={data?.key}
          />
        )}
      </>
    </DefaultModalLayout>
  );
}

const ValueContainer = styled.div`
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
`;
